/**
 * PlayerPhoto — Reusable player headshot from Sleeper CDN
 * Falls back to position-colored initials if image fails to load.
 */
import { useState } from "react";

const POS_COLORS = { QB: "#ff6b6b", RB: "#4ecdc4", WR: "#45b7d1", TE: "#f9ca24" };

export function PlayerPhoto({ playerId, name, position, size = 32, className = "" }) {
  const [failed, setFailed] = useState(false);
  const src = playerId ? `https://sleepercdn.com/content/nfl/players/thumb/${playerId}.jpg` : null;
  const initials = (name || "?").split(" ").map(w => w[0] || "").join("").slice(0, 2).toUpperCase();
  const bg = POS_COLORS[position] || "#333";

  if (!src || failed) {
    return (
      <div
        className={`shrink-0 flex items-center justify-center rounded-full ${className}`}
        style={{ width: size, height: size, backgroundColor: `${bg}22`, border: `1px solid ${bg}44` }}
        data-testid={`player-photo-${playerId || "fallback"}`}
      >
        <span style={{ color: bg, fontSize: size * 0.35, fontWeight: 700, fontFamily: "JetBrains Mono, monospace" }}>{initials}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name || ""}
      width={size}
      height={size}
      className={`shrink-0 rounded-full object-cover bg-[#1a1a1a] ${className}`}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
      loading="lazy"
      data-testid={`player-photo-${playerId}`}
    />
  );
}
